module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADASURBVHgB1ZSBDYMgEEWPTuAIjOAoHcEN2lG6QbsJI3QE3MBu8Hsn0ChaqNDE+JJLyCHP09xBtAcANEdL/4BFDcfTR0M1+MpEFLCSoxL44IVjwBLJXbeIpCqDPPdstV5m8Tv2q7RAlpaiTBYwsaxFPWOfnrxTUz0z4Yvq6T8ruGkYUI5d6DnZJQ4YzCcmplut2Uvt5MFxKuCa+LayLy85Uw64ntSTdZDreH8TcP82rih546iMUD4nvgd7pdSDDssbCTdbL6r4aDAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab4-active.png
// module id = GMRb
// module chunks = 1